import { type TypographyOptions } from "@mui/material/styles/createTypography";

const typography: TypographyOptions = {
  fontFamily: "Helvetica, sans-serif",

  // Headings
  h1: { fontSize: "2.5rem", fontWeight: 700, lineHeight: 1.2 },
  h2: { fontSize: "2rem", fontWeight: 700, lineHeight: 1.25 },
  h3: {
    fontSize: "1.75rem",
    fontWeight: 600,
    lineHeight: 1.3,
    marginBottom: ".5rem",
  },
  h4: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.35 },
  h5: { fontSize: "1.25rem", fontWeight: 500, lineHeight: 1.4 },
  h6: { fontSize: "1.25rem", fontWeight: 500, lineHeight: 1.6 }, // table headers use this

  // Body text
  body1: { fontSize: "1rem", lineHeight: 1.5 }, // default paragraph
  body2: { fontSize: "0.875rem", lineHeight: 1.4, color: "#666" }, // secondary text

  // Buttons & labels
  button: { textTransform: "uppercase", fontWeight: 500 },
};

export default typography;
